import { render, staticRenderFns } from "./OffersSingle.vue?vue&type=template&id=2d93bee9&"
import script from "./OffersSingle.vue?vue&type=script&lang=ts&"
export * from "./OffersSingle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports